import {
    ChoiceGroup,
    Dropdown,
    IChoiceGroupOption,
    IDropdownOption,
    IDropdownStyles,
    Panel
} from '@fluentui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Theme } from '../../Models/Constants/Enums';
import { Locale } from '@microsoft/iot-cardboard-js';
import { useLanguageContext } from '../../Models/Context/I18nProvider';
import { languageToCodeMapping } from '../../Services/Utils';
import { useThemeContext } from '../../Theming/ThemeProvider';

interface ISettingsPanelProps {
    isOpen: boolean;
    onDismiss: () => void;
}

export const SettingsPanel: React.FC<ISettingsPanelProps> = ({
    isOpen,
    onDismiss
}) => {
    const { selectedTheme, setSelectedTheme } = useThemeContext();
    const { selectedLang, setSelectedLang } = useLanguageContext();
    const { t } = useTranslation();

    const themeChoices: IChoiceGroupOption[] = [
        {
            key: 'kraken',
            iconProps: {
                iconName:
                    selectedTheme === Theme.Kraken ? 'Color' : 'ColorSolid'
            },
            imageSize: { width: 32, height: 32 },
            color: 'blue',
            text: t('kraken')
        },
        {
            key: 'light',
            iconProps: {
                iconName: selectedTheme === Theme.Light ? 'Color' : 'ColorSolid'
            },
            imageSize: { width: 32, height: 32 },
            text: t('light')
        },
        {
            key: 'dark',
            iconProps: {
                iconName: selectedTheme === Theme.Dark ? 'Color' : 'ColorSolid'
            },
            imageSize: { width: 32, height: 32 },
            text: t('dark')
        }
    ];

    const languageOptions: IDropdownOption[] = Object.keys(
        languageToCodeMapping
    ).map((k) => ({ key: k, text: (languageToCodeMapping as any)[k] }));

    const dropdownStyles: Partial<IDropdownStyles> = {
        root: { width: '100%', paddingTop: 24 }
    };

    const handleOnChangeTheme = (
        _ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
        option?: IChoiceGroupOption
    ) => {
        setSelectedTheme(option?.key as Theme);
    };

    const handleOnChangeLang = (
        _event: React.FormEvent<HTMLDivElement>,
        option?: IDropdownOption<any> | undefined,
        _index?: number | undefined
    ) => {
        setSelectedLang(option?.key as Locale);
    };

    return (
        <Panel
            isLightDismiss
            isOpen={isOpen}
            onDismiss={onDismiss}
            closeButtonAriaLabel={t('close')}
            headerText={t('settings')}
            styles={{
                main: { minWidth: 350 },
                scrollableContent: { background: 'unset' }
            }}
        >
            <ChoiceGroup
                label={t('theme')}
                defaultSelectedKey={selectedTheme}
                options={themeChoices}
                onChange={handleOnChangeTheme}
            />

            <Dropdown
                placeholder={t('language')}
                label={t('language')}
                options={languageOptions}
                styles={dropdownStyles}
                onChange={handleOnChangeLang}
                selectedKey={selectedLang}
            />
        </Panel>
    );
};
